'use strict';

// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

module.exports = require('./pt-BR');


//////////////////
// WEBPACK FOOTER
// ./~/grommet/messages/pt.js
// module id = 202
// module chunks = 0